import axios from '@/lib/axios';

const host = '';

/**
 * 登录
 */
export function login(params) {
	return axios.get(`${host}/api/login`, params);
}

/**
 * 获取当前窗口期
 */
export function periodInfo(params) {
	return axios.get(`${host}/api/periodInfo`, params);
}

/**
 * 校验参选资格
 */
export function checkQualification(params) {
	return axios.get(`${host}/api/checkQualification`, params);
}

/**
 * 我的抽选
 */
export function myRegistration(params) {
	return axios.get(`${host}/api/myRegistration`, params);
}

/**
 * 获取抽选场次列表
 */
export function ticketConfig(params) {
	return axios.get(`${host}/api/ticketConfig`, params);
}

/**
 * 确认/更新抽选登记
 */
export function registration(params) {
	return axios.post(`${host}/api/registration`, params);
}

/**
 * 获取邀请码
 */
export function inviteCode(params) {
	return axios.get(`${host}/api/inviteCode`, params);
}

/**
 * 加入队伍
 */
export function addTeam(params) {
	return axios.post(`${host}/api/addTeam`, params);
}

/**
 * 解散/退出队伍
 */
export function quitTeam(params) {
	return axios.get(`${host}/api/quitTeam`, params);
}

/**
 * 立即支付
 */
export function pay(params) {
	return axios.formPost(`${host}/api/pay`, params);
}

/**
 * 获取队伍详情
 */
export function teamInfo(params) {
	return axios.get(`${host}/api/teamInfo`, params);
}
